module.exports = __webpack_public_path__ + "img/2.2590b869.jpg";